module.exports = __webpack_public_path__ + "img/facebook-f-blue.5797d498.svg";